import React, { FC, ComponentProps } from 'react';
import { BoxV2 as Box } from 'portal-commons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-regular-svg-icons';

const AddEmailBtn: FC<ComponentProps<typeof Box>> = ({
  buttonText,
  sx,
  onClick,
  ...restProps
}) => {
  return (
    <Box
      data-testid="addEmailButton"
      role="button"
      tabIndex={0}
      sx={{
        p: '5px 10px',
        color: '#0091B3',
        fontSize: '14px',
        fontWeight: 500,
        lineHeight: 'normal',
        display: 'inline-block',
        textAlign: 'left',
        width: 'fit-content',
        cursor: 'pointer',
        position: 'absolute',
        top: '100%',
        left: 0,
        zIndex: 1,
        ...sx,
      }}
      onClick={(e: React.MouseEvent<HTMLDivElement>) => onClick?.(e)}
      {...restProps}
    >
      <FontAwesomeIcon icon={faPlus} style={{ marginRight: '8px' }} />
      {buttonText ? buttonText : 'Add New Email Address'}
    </Box>
  );
};
export default AddEmailBtn;
